import React, { useState } from 'react';
import '../styles/SideBarLeft.css';
import '../styles/SideBarToggle.css';
import '../styles/phcolours.css';

import useUIPresentationMode from '../helpers/useUIPresentationMode.js';

import CollapseIconHover from '../../images/IconLeftArrowBlue@3x.png';
import CollapseIcon from '../../images/IconLeftArrowGrey@3x.png';

//import FraemohsLogo from '../../images/FraemohsLogoLight@3x.png';
import FraemohsHousLandLogo from '../../images/FraemohsHL@3x.png';
import FraemohsFirstLogo from '../../images/FraemohsFirstLogo@3x.png';


export default function StockSideBarLeft({
  listingTypeSpec = null,
  franchiseURLParam = null,
  isVisible = true,
  onRequestClose = () => { },
  showListingAdminButton = false,
  onOpenListingAdmin = () => { },
  uniqueOptions = { bedrooms: [], availability: [], progress: [], buildSpec: [], franchise: [] },
  filters = { bedrooms: new Set(), availability: new Set(), progress: new Set(), buildSpec: new Set(), franchise: new Set() },
  setFilters = () => { },
  onClearAndZoom = () => { },
}) {

  const [isSideBarCollapseButtonHovering, setIsSideBarCollapseButtonHovering] = useState(false);

  const { presentationModeSize } = useUIPresentationMode();
  const hideLogo = presentationModeSize === 5;


  // Helper: how many of the currently visible options are selected?
  const countSelectedVisible = (selectedSet, visibleArr) => {
    const visible = new Set(visibleArr ?? []);
    let count = 0;
    if (selectedSet) {
      selectedSet.forEach(v => { if (visible.has(v)) count += 1; });
    }
    return { count, total: visible.size };
  };

  const showClear = (() => {
    // Bedrooms (always shown if options exist)
    if ((uniqueOptions?.bedrooms?.length ?? 0) > 0) {
      const { count, total } = countSelectedVisible(filters?.bedrooms, uniqueOptions.bedrooms);
      if (count !== total) return true;
    }

    // Franchise (only when NOT URL-forced and there’s actually a choice)
    if (!franchiseURLParam && (uniqueOptions?.franchise?.length ?? 0) > 1) {
      const { count, total } = countSelectedVisible(filters?.franchise, uniqueOptions.franchise);
      if (count !== total) return true;
    }

    // BuildSpec (hidden when listingTypeSpec === 'ff')
    if (listingTypeSpec !== 'ff' && (uniqueOptions?.buildSpec?.length ?? 0) > 0) {
      const { count, total } = countSelectedVisible(filters?.buildSpec, uniqueOptions.buildSpec);
      if (count !== total) return true;
    }

    // Availability (only meaningful when >1)
    if ((uniqueOptions?.availability?.length ?? 0) > 1) {
      const { count, total } = countSelectedVisible(filters?.availability, uniqueOptions.availability);
      if (count !== total) return true;
    }

    // Progress
    if ((uniqueOptions?.progress?.length ?? 0) > 0) {
      const { count, total } = countSelectedVisible(filters?.progress, uniqueOptions.progress);
      if (count !== total) return true;
    }

    return false;
  })();

  
  /*-----------------------------------------------------------------------------*/

  
  return (
    <div
      className="sidebar"
      style={{
        width: '100%',
        flex: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderRight: isVisible ? '0.75px solid #596A99' : 'none',
        transition: 'flex-basis 0.3s ease, opacity 0.3s ease',
        opacity: isVisible ? 1 : 0,
      }}
    >
      {/* Minimise toggle */}
      <button
        className="sidebar-toggle-button sidebar-left-toggle-button-expanded"
        onClick={onRequestClose}
        onMouseEnter={() => setIsSideBarCollapseButtonHovering(true)}
        onMouseLeave={() => setIsSideBarCollapseButtonHovering(false)}
      >
        <img
          src={isSideBarCollapseButtonHovering ? CollapseIconHover : CollapseIcon}
          alt="Hide Sidebar"
        />
      </button>

      <div className="sidebar-inner">

        {/* Logo at the top */}
        {!hideLogo && (
          <div className="sidebar-logo-container">

            {listingTypeSpec === 'ff' ? (
              <img
                src={FraemohsFirstLogo}
                alt="Fraemohs Logo"
                className="sidebar-logo"
                style={{ width: '100%', height: 'auto', objectFit: 'contain', marginTop: "15px", marginBottom: "10px" }}  // Fraemohs First logo.
              />
            ) : (
              <img
                src={FraemohsHousLandLogo}
                alt="Fraemohs Logo"
                className="sidebar-logo"
                //style={{ width: 'auto', height: '110px' }}  // PlanHub logo.
                style={{ width: '100%', height: 'auto', objectFit: 'contain', marginTop: "15px", marginBottom: "10px" }}  // Fraemohs First logo.
              />
            )}

          </div>
        )}

        <div className="sidebar-heading-row">
          <span className="sidebar-heading-label active">Filter</span>
        </div>

        {/* Filters section (Step 2B: display only, not yet applied) */}
        <div style={{ marginTop: '12px' }}>

          {/* <div style={{ fontWeight: 600, fontSize: 13, marginBottom: '6px', marginTop: '12px'}}>Franchise</div>*/}
          <div style={{ fontWeight: 600, fontSize: 13, marginTop: '12px', marginBottom: '6px' }}></div>

          {!franchiseURLParam && uniqueOptions.franchise && uniqueOptions.franchise.length > 1 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {uniqueOptions.franchise.map((v) => (
                <label
                  key={`franchise-${v}`}
                  className="checkbox"
                  style={{ margin: "2px 0 0 10px", padding: 0 }}
                >
                  <input
                    type="checkbox"
                    checked={filters.franchise.has(v)}
                    onChange={() => {
                      const next = new Set(filters.franchise);
                      next.has(v) ? next.delete(v) : next.add(v);
                      setFilters({ ...filters, franchise: next });
                    }}
                  />
                  <span>{v}</span>
                </label>
              ))}
            </div>
          )}

          {/* <div style={{ fontWeight: 600, fontSize: 13, marginBottom: '6px', marginTop: '12px'}}>Type</div>*/}
          <div style={{ fontWeight: 600, fontSize: 13, marginTop: '12px', marginBottom: '25px' }}></div>

          {listingTypeSpec !== 'ff' &&
            uniqueOptions.buildSpec &&
            uniqueOptions.buildSpec.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {uniqueOptions.buildSpec.map((v) => (
                  <label
                    key={`buildSpec-${v}`}
                    className="checkbox"
                    style={{ margin: "2px 0 0 10px", padding: 0 }}
                  >
                    <input
                      type="checkbox"
                      checked={filters.buildSpec.has(v)}
                      onChange={() => {
                        const next = new Set(filters.buildSpec);
                        next.has(v) ? next.delete(v) : next.add(v);
                        setFilters({ ...filters, buildSpec: next });
                      }}
                    />
                    <span>{v}</span>
                  </label>
                ))}
              </div>
            )}

          {/* <div style={{ fontWeight: 600, fontSize: 13, marginBottom: '6px', marginTop: '12px'}}>Availability</div>*/}
          <div style={{ fontWeight: 600, fontSize: 13, marginTop: '12px', marginBottom: '25px' }}></div>

          {uniqueOptions.availability && uniqueOptions.availability.length > 1 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {uniqueOptions.availability.map((v) => (
                <label
                  key={`avail-${v}`}
                  className="checkbox"
                  style={{ margin: "2px 0 0 10px", padding: 0 }}
                >
                  <input
                    type="checkbox"
                    checked={filters.availability.has(v)}
                    onChange={() => {
                      const next = new Set(filters.availability);
                      next.has(v) ? next.delete(v) : next.add(v);
                      setFilters({ ...filters, availability: next });
                    }}
                  />
                  <span>{v}</span>
                </label>
              ))}
            </div>
          )}

          {/* <div style={{ fontWeight: 600, fontSize: 13, marginBottom: '6px', marginTop: '12px'}}>Progress</div>*/}
          <div style={{ fontWeight: 600, fontSize: 13, marginTop: '12px', marginBottom: '25px' }}></div>

          {uniqueOptions.progress && uniqueOptions.progress.length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {uniqueOptions.progress.map((v) => (
                <label
                  key={`prog-${v}`}
                  className="checkbox"
                  style={{ margin: "2px 0 0 10px", padding: 0 }}
                >
                  <input
                    type="checkbox"
                    checked={filters.progress.has(v)}
                    onChange={() => {
                      const next = new Set(filters.progress);
                      next.has(v) ? next.delete(v) : next.add(v);
                      setFilters({ ...filters, progress: next });
                    }}
                  />
                  <span>{v}</span>
                </label>
              ))}
            </div>
          )}

          {/* <div style={{ fontWeight: 600, fontSize: 13, marginBottom: '6px', marginTop: '12px'}}>Bedrooms</div>*/}
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: '6px', marginTop: '25px' }}></div>

          {uniqueOptions.bedrooms && uniqueOptions.bedrooms.length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {uniqueOptions.bedrooms.map((b) => (
                <label
                  key={`bed-${b}`}
                  className="checkbox"
                  style={{ margin: "2px 0 0 10px", padding: 0 }}
                >
                  <input
                    type="checkbox"
                    checked={filters.bedrooms.has(b)}
                    onChange={() => {
                      const next = new Set(filters.bedrooms);
                      next.has(b) ? next.delete(b) : next.add(b);
                      setFilters({ ...filters, bedrooms: next });
                    }}
                  />
                  <span>{b} bedrooms</span>
                </label>
              ))}
            </div>
          )}

        </div>

        {/* TradeMe link styled like a table row with overrides */}
        {showClear && (
          <div
            className="sidebarRight-landinfo-row"
            onClick={() => {
              setFilters({
                bedrooms: new Set(uniqueOptions.bedrooms),
                availability: new Set(uniqueOptions.availability),
                progress: new Set(uniqueOptions.progress),
                buildSpec: new Set(uniqueOptions.buildSpec),
                franchise: new Set(uniqueOptions.franchise),
              });
              onClearAndZoom();
            }}
            style={{
              marginTop: "35px",
              justifyContent: "center",   // centre horizontally
              textAlign: "center",        // centre text in case of wrapping
              cursor: "pointer",
              backgroundColor: "var(--phwashedorangebackground)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "var(--phorangefont)";
              e.currentTarget.querySelector("span").style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "var(--phwashedorangebackground)";
              e.currentTarget.querySelector("span").style.color = "var(--phorangefont)";
            }}
          >
            <span style={{ color: "var(--phorangefont)", fontWeight: 500 }}>
              Clear filters
            </span>
          </div>
        )}


      </div>

      <div className="sidebar-footer">
        {showListingAdminButton && (
          <>
            <button
              type="button"
              className="stock-listing-admin-button"
              onClick={onOpenListingAdmin}
            >
              Listing Admin
            </button>
          </>
        )}
        <div className="copyright">© Fraemohs 2026</div>
      </div>
    </div>
  );
}
